import { ApiResponseType } from '@/types';
import { NotificationsRes } from '@/api/types/notificationsType';
import { AxiosResponse } from 'axios';

/**
 * Extracts list items from API responses.
 * Matches list pages that read `response?.data?.data` (e.g. request list).
 */
export const extractApiListData = <T>(
  response: AxiosResponse<ApiResponseType<unknown>> | undefined
): T[] => {
  const listData = response?.data?.data;

  if (Array.isArray(listData)) {
    return listData as T[];
  }

  if (
    listData &&
    typeof listData === 'object' &&
    'data' in listData &&
    Array.isArray((listData as { data: T[] }).data)
  ) {
    return (listData as { data: T[] }).data;
  }

  return [];
};

export const parseNotificationsList = (
  response: AxiosResponse<ApiResponseType<unknown>> | undefined
): NotificationsRes[] => extractApiListData<NotificationsRes>(response);

export const parseRequestList = <T>(
  response: AxiosResponse<ApiResponseType<unknown>> | undefined
): T[] => extractApiListData<T>(response);

export const parseNotificationsTotalCount = (
  response: AxiosResponse<ApiResponseType<unknown>> | undefined,
  fallbackLength: number
): number => {
  const headerCount = response?.headers?.['x-total-count'];

  if (typeof headerCount === 'number') {
    return headerCount;
  }

  if (typeof headerCount === 'string') {
    const parsed = Number(headerCount);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

  return response?.data?.totalCount ?? fallbackLength;
};
